import _ from 'lodash';
 
export const getExpensesForProduct=(state, productId)=>{    
    const expenses = state.expenses.expenses;
    return expenses[productId]?_.orderBy(expenses[productId], ['created_at']) : [];
}

export const isExpensesLoading=(state)=>{
    return state.expenses.loading;
}
 
export const userExpenses=(expenses, userId)=>{
    if(!expenses){
        return undefined;
    }
    return expenses.filter(booking=>(expenses.spent_by===userId));
}
 